import useAuth from './useAuth';
import { ROLES } from '../config/constants';

const usePermissions = () => {
  const { role } = useAuth();

  const isAdmin = role === ROLES.ADMIN;
  const isManager = role === ROLES.MANAGER;
  const isAssociate = role === ROLES.ASSOCIATE;
  const isBanker = role === ROLES.BANKER;
  const isConsultancy = role === ROLES.CONSULTANCY;

  const hasRole = (...roles) => roles.includes(role);

  const canCreateStudent = hasRole(ROLES.ADMIN, ROLES.MANAGER, ROLES.ASSOCIATE, ROLES.CONSULTANCY);
  const canEditStudent = hasRole(ROLES.ADMIN, ROLES.MANAGER, ROLES.ASSOCIATE, ROLES.CONSULTANCY);
  const canDeleteStudent = isAdmin;
  const canUploadDocuments = hasRole(ROLES.ADMIN, ROLES.MANAGER, ROLES.ASSOCIATE, ROLES.CONSULTANCY);
  const canMergeDocuments = hasRole(ROLES.ADMIN, ROLES.MANAGER, ROLES.ASSOCIATE, ROLES.CONSULTANCY);
  const canAssignManager = isAdmin;
  const canAssignAssociate = hasRole(ROLES.ADMIN, ROLES.MANAGER);
  const canAssignBanker = hasRole(ROLES.ADMIN, ROLES.MANAGER);
  const canManageUsers = isAdmin;
  const canViewReports = hasRole(ROLES.ADMIN, ROLES.MANAGER);
  const canViewDashboardFull = hasRole(ROLES.ADMIN, ROLES.MANAGER);
  const canViewConsultancyPortal = isConsultancy;

  return {
    role,
    isAdmin,
    isManager,
    isAssociate,
    isBanker,
    isConsultancy,
    hasRole,
    canCreateStudent,
    canEditStudent,
    canDeleteStudent,
    canUploadDocuments,
    canMergeDocuments,
    canAssignManager,
    canAssignAssociate,
    canAssignBanker,
    canManageUsers,
    canViewReports,
    canViewDashboardFull,
    canViewConsultancyPortal,
  };
};

export default usePermissions;
